export default "__VITE_ASSET__CryFjaox__"